export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/aJ1v8acvXB4GVyUZAdub6S/HVAC_LOOK_INSIDE_1.jpg',
    alt: 'Sample page Heat Moves in Three Ways, illustrating conduction, convection and radiation in a room cross-section',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/sZtrjkmsCsSgbYFH8UuDTo/HVAC_LOOK_INSIDE_2.jpg',
    alt: 'Sample page Pressure Decides the Boiling Point, explaining the pressure-temperature relationship in a refrigeration system',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/b3ohhnuEKb31g35juUqvYs/HVAC_LOOK_INSIDE_3.jpg',
    alt: 'Sample page Specific Heat Tells How Much Energy a Degree Costs, with the Q = m × cp × ΔT formula and a worked example',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/wTd7PK2Jozo5qqetxXU2JY/HVAC_LOOK_INSIDE_4.jpg',
    alt: 'Sample page One Chart Holds All the Properties of Air, an annotated anatomy of the psychrometric chart',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/2hUkjRWESH1yxC4j12qjV6/HVAC_LOOK_INSIDE_5.jpg',
    alt: 'Sample page HVAC Fundamentals Field Card, with key conversions, formulas, pressure rules, air rules and pre-work checks',
  },
];
